import { createQS } from '@shared/utils/qs';
import { MESSAGES } from '@domain/integrations/integration-strategies/oauth-strategy/oauth-strategy.constants';

import { ROUTES } from '../../integrations.constants';

type OAuthParams = {
  'redirect_uri': string
  state: string
  'client_id': string
  scope: string
  'response_type': string
  prompt: string
  'access_type': string
}

type CreateSSOParams = {
  providerId: string
  clientId: string
  scopes: Array<string>
  responseType: string
}

type ObjectWithKeys = {
  [key: string]: string
}

// eslint-disable-next-line no-unused-vars
export const isStateCodeValid = (providerId: string, state: string): boolean => true;

export const shouldThrowWarning = message => Boolean(MESSAGES[message]);

const generateStateCode = (providerId: string): string => {
    const state = `_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem(`quantic-oauth-${providerId}`, state);

    return state;
};

export const getRedirectUri = (
    providerId: string,
):string => `${window.location.origin}${ROUTES.OAUTH_CALLBACK.replace(':providerId', providerId)}`;

export const createSSOUrl = (issuerUrl: string, params: CreateSSOParams): string => {
    const oauthParams: OAuthParams = {
        redirect_uri: getRedirectUri(params.providerId),
        state: generateStateCode(params.providerId),
        client_id: params.clientId,
        scope: params.scopes.join(' '),
        response_type: params.responseType,
        prompt: 'consent',
        access_type: 'offline',
    };

    return `${issuerUrl}?${createQS(oauthParams)}`;
};

export const getAdditionalParamsFromQuerystring = (
    qsParams: Partial<ObjectWithKeys>,
    forwardPropsMap: ObjectWithKeys,
) => Object
    .entries(forwardPropsMap || {})
    .filter(([key]) => !!qsParams[key])
    .reduce((acc, [key, value]) => ({
        ...acc,
        [value]: qsParams[key],
    }), {});

export const getHomePathForIntegrationId = (
    integrationId: string,
) => `${ROUTES.LIST}/#tour-${integrationId.replace('_', '-')}`;
